export default ['Flagged', 'Unflagged'];
